
// tslint:disable:max-file-line-count

import { CSSProperties } from 'react';
import '../fonts/proxima-nova-webfontkit.css';
import { CONSTANTS } from './styleConstants';

export const cardShadow = '1px 1px 5px rgba(0, 0, 0, 0.17)';
export const largeShadow = '0px 10px 35px rgba(0, 0, 0, 0.08)';
export const navBarBreakPoint = 600;
export const defaultCardMemberPaddingBottom = 20;

const inputBackgroundColor = '#4F4F5E';
const transparentWhite = '#FFFFFFEE';
const lightGrey = '#00000044';
const midGrey = '#000000AA';
const darkGrey = '#000000CC';
export const darkestGrey = '#111111';
const transparent = '#00000000';
export const notificationRed = '#F12929';
const midWhite = '#FFFFFF99';
const fullWhite = '#FFFFFFDD';
const loginSignupLoginButtonColor = '#4377AF';
// export const disabledButtonColor = '#00000033';
export const blueColor = '#7CA9D0';
export const darkBlueColor = '#3077B4';

// export const searchTagButtonContainer: CSSProperties = {
//     height: 35,
//     backgroundColor: darkBlueColor,
//     color: 'white',
//     borderRadius: 25,
//     marginRight: 20,
//     display: 'flex',
//     flexDirection: 'row',
//     cursor: 'pointer',
//     alignItems: 'center',
//     paddingTop: 3,
//     outline: 'none'
// };

// export const searchTagButtonText: CSSProperties = {
//     marginLeft: 10
// };
//
// export const searchTagXButtonImage: CSSProperties = {
//     height: 10,
//     width: 18,
//     marginTop: 0,
//     marginLeft: 10,
//     objectFit: 'contain'
// };

export const userNamePredictiveInputDropDown: CSSProperties = {
    width: '100.0%',
    position: 'relative',
    zIndex: 900,
    backgroundColor: 'white',
    top: 0,
    left: 0,
    borderLeft: '1px solid rgba(0, 0, 0, 0.267)',
    borderRight: '1px solid rgba(0, 0, 0, 0.267)',
    borderBottom: '0.5px solid rgba(0, 0, 0, 0.267)',
    maxHeight: 335,
    overflowY: 'scroll'
};

export const modalInputHeaderText: CSSProperties = {
    marginTop: 20,
    marginLeft: 0,
    marginBottom: 10,
    fontWeight: 'bold',
    fontSize: 18
};

export const updateProfileImageView: CSSProperties = {
    height: 150,
    width: 150,
    borderRadius: 75,
    objectFit: 'cover',
    boxShadow: largeShadow
};

export const innerProfileUpdateContainer: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    backgroundColor: 'white',
    height: '100%',
    padding: 34,
    paddingTop: 33,
    paddingLeft: 37,
    borderRadius: 3
};

export const updateProfileModalContainer: CSSProperties = {
    width: 760,
    height: 330,
    paddingLeft: 10
};

export const leftProfileModalContainer: CSSProperties = {
    width: 600,
    height: '100%'
};

export const rightProfileModalContainer: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    width: 300,
    height: '100%'
};

export const profileUpdateInputHeaderText: CSSProperties = {
    fontSize: 17,
    marginTop: 10
};

export const editModalContainer: CSSProperties = {
    minWidth: 900,
    padding: 25,
    paddingLeft: 30,
    paddingRight: 30,
    backgroundColor: 'white',
    borderRadius: 2
};

export const modalActionListStyle: CSSProperties = {
    width: '40%',
    paddingLeft: 20,
    maxHeight: 300,
    marginBottom: 20,
    overflowY: 'scroll'
};

export const fullFlexWidthRow: CSSProperties = {
    width: '100%',
    display: 'flex',
    flexDirection: 'row'
};

export const tagTitle: CSSProperties = {
    color: 'black',
    fontSize: 14,
    fontWeight: 600
};

export const flexRow: CSSProperties = {
    display: 'flex',
    flexDirection: 'row'
};

export const fullWidth: CSSProperties = {
    width: '100%'
};

// export const leftSideTagContainer: CSSProperties = {
//     width: '60%',
//     height: '100%',
//     backgroundColor: '#00000000',
//     display: 'flex',
//     flexDirection: 'column'
// };
//
// export const tagContainerDivider: CSSProperties = {
//     width: '0.2%',
//     height: '80%',
//     backgroundColor: 'white'
// };

// export const rightSideTagContainer: CSSProperties = {
//     width: '39.8%',
//     height: '100%',
//     backgroundColor: '#00000000'
// };
//
// export const uploaderMainContainer: CSSProperties = {
//     width: '100%',
//     paddingLeft: 30,
//     display: 'flex',
//     flexDirection: 'row'
// };

export const dropzoneContainer: CSSProperties = {
    width: 360,
    height: 300
};

// export const uploaderHeaderContainer: CSSProperties = {
//     display: 'flex',
//     flexDirection: 'column',
//     width: '100%'
// };
//
// export const topRowHeaderContainer: CSSProperties = {
//     width: '100%',
//     display: 'flex',
//     flexDirection: 'row'
// };
//
// export const tagHeaderFont: React.CSSProperties = {
//     marginTop: 10,
//     marginLeft: 20,
//     fontSize: 14,
//     color: 'white',
//     fontWeight: 'lighter',
//     fontStyle: 'italic'
// };

// export const horizontalScrollTagRow: React.CSSProperties = {
//     width: '100.0%',
//     height: '50%',
//     display: 'flex',
//     flexDirection: 'row',
//     marginRight: 20,
//     alignItems: 'center',
//     paddingLeft: 20,
//     paddingRight: 30
// };
//
// export const tagStyle: React.CSSProperties = {
//     backgroundColor: '#00000000',
//     border: 'none',
//     outline: 'none',
//     color: 'white',
//     fontWeight: 'bolder',
//     marginLeft: 0,
//     marginRight: 15,
//     marginTop: 3,
//     cursor: 'pointer',
//     display: 'flex',
//     whiteSpace: 'nowrap'
// };

// export const addTagButton: React.CSSProperties = {
//     color: 'white',
//     fontWeight: 'lighter',
//     fontSize: 14,
//     backgroundColor: '#00000000',
//     border: 'none',
//     outline: 'none',
//     cursor: 'pointer'
// };
//
// export const addTagButtonContainer: React.CSSProperties = {
//     width: '100%',
//     height: '100%',
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     paddingLeft: 10,
//     paddingRight: 40
// };
//
// export const newArtifactCellContainer: CSSProperties = {
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     flexDirection: 'column',
//     width: 270,
//     boxShadow: largeShadow,
//     borderRadius: 3,
//     marginRight: 15,
//     marginBottom: 20,
//     marginTop: -40
// };

export const recordingButtonStyle: React.CSSProperties = {
    height: 80,
    width: 80,
    borderRadius: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer'
};

// export const dynamicCollectionFilterText: CSSProperties = {
//     fontWeight: 900,
//     fontSize: 16,
//     color: 'black',
//     cursor: 'pointer'
// };
//
// export const dynamicCollectionFilterImage = {
//     height: 20,
//     width: 13,
//     objectFit: 'contain',
//     marginLeft: 7,
//     cursor: 'pointer'
// };

// export const trailButtonStyle: React.CSSProperties = {
//     backgroundColor: '#00000000',
//     border: 'none',
//     outline: 'none',
//     marginLeft: 5,
//     marginRight: 5,
//     color: darkBlueColor,
//     cursor: 'pointer'
// };
//
// export const secondaryTextTrailText = {
//     color: '#222222'
// };
//
// export const uploadArtifactModalButtonContainer: CSSProperties = {
//     width: '100%',
//     height: 100,
//     paddingTop: 25,
//     paddingRight: 30,
//     display: 'flex',
//     flexDirection: 'row'
// };
//
// export const newArtifactUploadHeaderText = {
//     fontSize: 25,
//     marginTop: 10,
//     paddingLeft: 33,
//     color: 'black',
//     whiteSpace: 'nowrap'
// };
//
// export const newArtifactUploadSubHeaderText: CSSProperties = {
//     fontSize: 18,
//     fontWeight: 900,
//     marginTop: 10,
//     color: 'black',
//     whiteSpace: 'nowrap'
// };

export const dropDownFilterBackground: CSSProperties = {
    position: 'fixed',
    left: 0,
    top: 0,
    width: '100%',
    backgroundColor: '#00000000',
    height: '100%',
    zIndex: 10
};

export const familyInviteHeaderFont: CSSProperties = {
    fontSize: 22,
    fontWeight: 900,
    marginBottom: 25
};

export const familyInviteSubText = {
    fontSize: 14
};

export const familyInviteInputStyle = {
    width: 500,
    height: 45,
    border: '0.5px solid #00000033',
    color: 'black',
    fontSize: 16,
    paddingLeft: 20,
    outline: 'none'
};

export const createFamilyModal: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 900,
    backgroundColor: 'white',
    boxShadow: cardShadow,
    padding: 35,
    paddingBottom: 70,
    paddingTop: 20
};

export const textContainer: React.CSSProperties = {
    height: '100%',
    backgroundColor: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: 20
};

export const familyMemberImageStyle: CSSProperties = {
    width: 80,
    height: 80,
    marginRight: 10,
    boxShadow: cardShadow,
    objectFit: 'cover'
};

export const loginInputIconContainer: CSSProperties = {
    position: 'relative',
    top: -34,
    left: 15,
    height: 20,
    width: 20,
    objectFit: 'contain'
};

export const loginInputInputStyle = {
    width: '100%',
    fontSize: 13,
    height: 45,
    backgroundColor: inputBackgroundColor,
    borderRadius: 5,
    outline: 'none',
    border: 'none',
    color: transparentWhite,
    paddingLeft: 50,
    marginTop: -10
};

export const headerContainerStyle: CSSProperties = {
    width: '100%',
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
    padding: 25
};

// export const artifactPreviewContainerStyle: CSSProperties = {
//     width: 300,
//     height: '100%',
//     backgroundColor: 'white',
//     justifyContent: 'center',
//     alignItems: 'center',
//     paddingBottom: 15,
//     paddingTop: 25,
//     paddingRight: 20
// };
//
// export const tagInputHeaderFont = {
//     fontSize: 24,
//     color: darkestGrey,
//     marginBottom: 50
// };
//
// export const tagInputInputStyle = {
//     width: '80%',
//     border: '0.5px solid rgba(0,0,0,0.2)',
//     height: 40,
//     outline: 'none',
//     paddingLeft: 10,
//     marginTop: 5
// };

export const tagRowDisplayContainerStyle: CSSProperties = {
    width: '100%',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'row',
    paddingLeft: 25,
    paddingRight: 25
};

// export const artifactUploaderModalContainer: CSSProperties = {
//     width: 1310,
//     padding: 20,
//     paddingLeft: 0,
//     paddingRight: 0,
//     backgroundColor: 'white',
//     display: 'flex',
//     flexDirection: 'row',
//     minHeight: 660,
//     borderRadius: 3
// };

export const inlineTagDisplayContainer: CSSProperties = {
    position: 'relative',
    display: 'flex',
    marginRight: 20
};

export const uploadArtifactInputContainer: React.CSSProperties = {
    width: 360,
    minHeight: 50,
    paddingBottom: 4,
    cursor: 'pointer',
    border: '0.5px solid ' + lightGrey,
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 20,
    paddingTop: 4
};

// export const tagInputDisplayContainer = {
//     width: 400,
//     height: '100%',
//     backgroundColor: 'white',
//     paddingLeft: 25,
//     paddingTop: 25
// };

export const inlineTagDeleteButtonCircle: CSSProperties = {
    position: 'relative',
    bottom: 24,
    left: '100%',
    width: 12,
    height: 12,
    objectFit: 'contain',
    cursor: 'pointer'
};

export const tagRowCaptionTextStyle: CSSProperties = {
    fontStyle: 'italic',
    color: midGrey,
    marginBottom: 10,
    marginTop: 5
};

// export const artifactPreviewImageStyle = {
//     height: 170,
//     objectFit: 'contain',
//     float: 'right'
// };
//
// export const addTagToArtifactModalContainer: CSSProperties = {
//     width: 700,
//     paddingTop: 25,
//     paddingBottom: 10,
//     minHeight: 270,
//     backgroundColor: 'white',
//     flexDirection: 'row',
//     display: 'flex'
// };

export const inviteFamilyMemberHeaderTextStyle: CSSProperties = {
    width: '100%',
    fontSize: 25,
    color: darkGrey,
    fontWeight: 'bold',
    paddingLeft: 10
};

export const familyMemberExtraCountContainer: CSSProperties = {
    position: 'relative',
    top: -80,
    left: 0,
    width: 80,
    height: 80,
    backgroundColor: '#00000077'
};

export const addFamilyMembersModalContainer: CSSProperties = {
    width: 850,
    minHeight: 470,
    maxHeight: 900,
    backgroundColor: 'white',
    zIndex: 1000,
    borderRadius: 2
};

export const familyMemberCountContainer: CSSProperties = {
    marginTop: 50,
    paddingLeft: 35,
    height: 187
};

export const additionalMemberCountText: CSSProperties = {
    height: '100%',
    width: '100%',
    color: 'white',
    fontSize: 22,
    textAlign: 'center',
    paddingTop: 29,
    paddingRight: 3
};

export const familyMemberImageRow: CSSProperties = {
    width: '70%',
    height: 80,
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 20
};

export const inviteInputButtonContainerStyle: CSSProperties = {
    width: 500,
    height: 45,
    backgroundColor: 'white',
    alignItems: 'center',
    marginBottom: 20
};

export const inviteButtonContainerStyle = {
    width: '100%',
    backgroundColor: 'white',
    marginTop: 50,
    height: 75,
    paddingTop: 5,
    borderRadius: 3
};

// export const modalContainerStyle: CSSProperties = {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     backgroundColor: midGrey,
//     height: '100%',
//     width: '100%',
//     justifyContent: 'center',
//     alignItems: 'center',
//     display: 'flex'
// };

export const dropDownStyle = {
    height: 150,
    backgroundColor: transparent,
    position: CONSTANTS.position.ABSOLUTE,
    top: 6,
    right: -20,
    zIndex: 1000
};

export const dropDownContainerStyle: CSSProperties = {
    backgroundColor: 'white',
    boxShadow: '0px 0px 5px 2px rgba(0, 0, 0, 0.2)',
    zIndex: 1000,
    overflowY: 'scroll'
};

export const dropDownArrowStyle = {
    position: CONSTANTS.position.ABSOLUTE,
    width: 0,
    height: 0,
    marginLeft: '-0.5',
    top: 0,
    right: 28,
    boxSizing: 'border-box',
    border: '5px solid black',
    borderColor: 'transparent transparent #fff #fff ',
    transformOrigin: '0 0',
    transform: 'rotate(135deg)',
    boxShadow: '-2px 2px 3px 0px rgba(0, 0, 0, 0.2)'
};

export const dropDownItemStyle: CSSProperties = {
    display: CONSTANTS.FLEX,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: CONSTANTS.COLORS.LIGHT_GREY,
    color: CONSTANTS.COLORS.DARK_TEXT,
    height: 50,
    fontFamily: CONSTANTS.font.SEMIBOLD,
    backgroundColor: 'white'
};

export const dropDownItemHoverStyle = {
    display: CONSTANTS.FLEX,
    paddingLeft: 40,
    alignItems: CONSTANTS.flexAlign.CENTER,
    width: '100%',
    height: '100%'
};

// export const cardLabelText = {
//     fontSize: 18,
//     color: CONSTANTS.COLORS.DARK_TEXT
// };

export const defaultMemberCardStyle = {
    height: '100%',
    width: '100%',
    paddingBottom: defaultCardMemberPaddingBottom
};

export const fullContainer = {
    height: '100%',
    width: '100%',
    fontFamily: CONSTANTS.font.REGULAR
};

export const familyMemberCellImageStyle: React.CSSProperties = {
    height: '100%',
    width: '100%',
    objectFit: 'cover'
};

export const familyMemberCellContainerStyle = {
    height: '100%',
    width: '100%',
    boxShadow: cardShadow
};

export const familyMemberCellTextContainer = {
    height: '31%',
    width: '100%',
    paddingLeft: 8
};

export const familyMemberImageContainer = {
    height: '69%',
    width: '100%'
};

export const artifactCollectionCellImage: CSSProperties = {
    objectFit: CONSTANTS.objectFit.CONTAIN,
    backgroundColor: CONSTANTS.COLORS.DARK_BLUE_GREY,
    width: '100%',
    height: '100%'
};

export const bottomCardStackContainer = {
    height: 30,
    width: '100%'
};

export const cardLabelContainer = {
    display: CONSTANTS.FLEX,
    alignItems: CONSTANTS.flexAlign.CENTER,
    width: '100%'
};

export const imageCaptionText: CSSProperties = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: 'white',
    textAlign: CONSTANTS.textAlign.RIGHT,
    width: '100%',
    fontSize: 13,
    marginRight: 7
};

export const imageTitleContainer = {
    display: CONSTANTS.FLEX,
    alignItems: CONSTANTS.flexAlign.CENTER,
    position: CONSTANTS.position.RELATIVE,
    bottom: 25,
    left: '55%',
    width: '45%',
    height: 25,
    backgroundColor: 'rgba(0,0,0,0.44)',
    paddingLeft: 5,
    paddingRight: 3,
    borderTopLeftRadius: 3
};

// export const collectionDetailViewContainer = {
//     width: '100%',
//     height: '100%',
//     paddingRight: '7%',
//     paddingLeft: '7%',
//     paddingTop: 40
// };
//
// export const mainNavBar = {
//     display: CONSTANTS.FLEX,
//     alignItems: CONSTANTS.flexAlign.CENTER,
//     height: 92,
//     width: '100%',
//     backgroundColor: CONSTANTS.COLORS.DARK_BLUE_GREY,
//     paddingLeft: '7%',
//     paddingRight: '4.2%'
// };

export const TagTypeStylesMap: {[key: number]: any} = {
    1: {
        color: CONSTANTS.COLORS.DARK_BLUE_GREY,
        border: '1px solid black'
    },
    2: {
        color: CONSTANTS.COLORS.BLUE,
        border: '1px solid red'
    }
};

// export const subNavBar = {
//     display: CONSTANTS.FLEX,
//     alignItems: CONSTANTS.flexAlign.CENTER,
//     height: 80,
//     width: '100%',
//     backgroundColor: CONSTANTS.COLORS.SUB_NAV_BAR,
//     paddingLeft: '7.5%',
//     paddingRight: '7.5%'
// };

export const familyMemberType: CSSProperties = {
    fontWeight: 'bold',
    fontSize: 15,
    color: CONSTANTS.COLORS.DARK_TEXT,
    paddingTop: 10,
    marginBottom: 10
};

export const familyMemberNameText = {
    fontSize: 15,
    color: CONSTANTS.COLORS.DARK_TEXT,
    paddingTop: 15
};

export const cardStack = {
    base: {
        borderBottomLeftRadius: 1,
        borderBottomRightRadius: 1,
        width: '100%',
        height: '90%',
        paddingBottom: 8,
        boxShadow: cardShadow
    },

    first: {
        borderBottomLeftRadius: 1,
        borderBottomRightRadius: 1,
        marginLeft: '2.5%',
        marginRight: '2.5%',
        width: '95%',
        height: 5,
        boxShadow: cardShadow
    },

    second: {
        borderBottomLeftRadius: 1,
        borderBottomRightRadius: 1,
        marginLeft: '5%',
        marginRight: '5%',
        width: '90%',
        height: 5,
        boxShadow: cardShadow
    }
};

export const cardStackImageContainer = {
    height: '70%',
    width: '100%'
};

export const secondaryText = {
    fontSize: 12,
    color: CONSTANTS.COLORS.BLUE,
    width: '50%',
    display: CONSTANTS.display.INLINE
};

export const gridItemMapContainer: CSSProperties = {
    display: CONSTANTS.FLEX,
    flexDirection: CONSTANTS.flexDirection.ROW,
    width: '100%'
};

export const artifactEditCogStyle: CSSProperties = {
    position: 'relative',
    left: '90%',
    bottom: 20,
    height: 20,
    width: 20,
    cursor: 'pointer'
};

export const artifactCollectionCellContainer: CSSProperties = {
    height: '100%',
    width: '100%',
    backgroundColor: 'white',
    paddingBottom: 20,
    position: 'relative'
};

export const profileNameFont = {
    width: '100%',
    height: '100%',
    color: CONSTANTS.COLORS.LIGHT_GREY,
    fontSize: 14,
    textAlign: CONSTANTS.textAlign.CENTER,
    paddingTop: 5
};

export const profileNameContainer = {
    height: '35%',
    backgroundColor: CONSTANTS.NONE
};

export const profileImageStyle: CSSProperties = {
    display: CONSTANTS.FLEX,
    height: 53,
    width: 53,
    borderRadius: 27.5,
    objectFit: CONSTANTS.objectFit.COVER,
    marginTop: -3
};

// ToDo: Test this.
export const profileImageContainer: CSSProperties = {
    display: CONSTANTS.FLEX,
    flexDirection: CONSTANTS.flexDirection.ROW,
    height: '65%',
    backgroundColor: 'none',
    justifyContent: CONSTANTS.flexJustify.CENTER,
    paddingTop: 12
};

export const mainNavBarContainer: CSSProperties = {
    flex: 1,
    width: '100%',
    height: '100%',
    backgroundColor: CONSTANTS.NONE,
    flexDirection: CONSTANTS.flexDirection.ROW
};

export const userProfileImageContainerStyle: CSSProperties = {
    width: 180,
    height: '100%',
    backgroundColor: CONSTANTS.NONE,
    float: CONSTANTS.float.RIGHT,
    display: CONSTANTS.FLEX,
    flexDirection: CONSTANTS.flexDirection.COLUMN,
    alignItems: CONSTANTS.flexAlign.CENTER
} as CSSProperties;

export const dynamicContainerStyle: CSSProperties = {
    height: '100%',
    float: 'right'
};

// export const artifactCollectionContainer: CSSProperties = {
//     width: '100%',
//     height: '100%',
//     backgroundColor: 'white',
//     paddingRight: '7%',
//     paddingLeft: '7%',
//     paddingTop: 35
// };

export const tagFilterButton: CSSProperties = {
    marginRight: 20,
    marginLeft: 20,
    backgroundColor: CONSTANTS.COLORS.TRANSPARENT,
    borderWidth: 0,
    width: 300,
    fontSize: 18,
    outline: CONSTANTS.NONE,
    paddingTop: 5
};

export const uploadArtifactButton = {
    outline: 'none',
    height: 50,
    minWidth: 145,
    maxWidth: 250,
    fontSize: 16,
    boxShadow: largeShadow,
    backgroundColor: CONSTANTS.COLORS.DARK_BLUE_GREY,
    color: 'white',
    paddingTop: 2,
    borderRadius: 3,
    cursor: 'pointer'
};

export const imageCogStyle: CSSProperties = {
    width: 20,
    height: 20,
    objectFit: CONSTANTS.objectFit.CONTAIN
};
export const profileCollectionInnerCell = {
    width: '100%',
    height: '100%',
    backgroundColor: transparent
};

export const profileCollectionCellContainer = {
    width: '100%',
    height: '90%',
    backgroundColor: 'white',
    paddingBottom: '5%',
    paddingLeft: 2,
    paddingRight: 2,
    boxShadow: cardShadow
};

export const extraMemberCountDisplay: CSSProperties = {
    position: 'relative',
    height: '100%',
    width: '100%',
    backgroundColor: 'rgba(0,0,0,0.3)',
    top: '-100%'
};

export const extraMemberCountText: CSSProperties = {
    position: 'absolute',
    top: 26,
    fontSize: 20,
    color: 'rgba(255,255,255,0.9)',
    width: '100%',
    textAlign: 'center',
    paddingRight: 10,
    paddingTop: 3
};

export const largeExtraMemberCountDisplay: CSSProperties = {
    position: 'relative',
    height: '100%',
    width: '100%',
    backgroundColor: 'rgba(0,0,0,0.3)',
    top: '-100%'
};

export const largeExtraMemberCountText: CSSProperties = {
    position: 'absolute',
    top: 26,
    fontSize: 35,
    color: 'rgba(255,255,255,0.9)',
    width: '100%',
    textAlign: 'center',
    paddingRight: 10,
    paddingTop: 35
};

export const smallProfileImageContainer = {
    width: '25%',
    height: '100%',
    backgroundColor: 'white',
    display: 'inline-block',
    padding: 1.8
};

export const smallProfileImage: CSSProperties = {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
};

export const largeGridRow: CSSProperties = {
    width: '100%',
    height: '50%',
    backgroundColor: 'white',
    flexDirection: 'row'
};

export const profileGridContainer = {
    width: '100%',
    height: '75%',
    backgroundColor: 'grey',
    marginBottom: 12
};

export const largeProfileImageContainer = {
    height: '100%',
    width: '50%',
    backgroundColor: 'white',
    display: 'inline-block',
    padding: 2
};

export const largeProfileImageSplitStyle: CSSProperties = {
    objectFit: 'cover',
    height: '100%',
    width: '100%'
};

// export const artifactDetailHeaderContainer: CSSProperties = {
//     height: 80,
//     width: '100%',
//     borderBottom: '2px solid rgba(0,0,0,0.5)',
//     display: CONSTANTS.FLEX,
//     flexDirection: 'row'
// };
//
// export const artifactDetailMain = {
//     height: 630,
//     backgroundColor: 'white',
//     boxShadow: largeShadow
// };

export const titleText: CSSProperties = {
    width: '60%',
    height: '100%',
    fontSize: 24,
    fontWeight: 500,
    color: midGrey,
    paddingTop: 28,
    paddingLeft: 27
};

// export const sharedText: CSSProperties = {
//     height: '100%',
//     fontSize: 14,
//     fontWeight: 400,
//     color: midGrey,
//     fontStyle: 'italic',
//     paddingTop: 40,
//     whiteSpace: 'nowrap'
// };

export const loginSignupContainerStyle: CSSProperties = {
    width: 310,
    height: 800,
    backgroundColor: transparent,
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    marginTop: 50,
    alignItems: 'center'
};

export const forgotPasswordContainerStyle: CSSProperties = {
    width: 310,
    height: 800,
    backgroundColor: transparent,
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    marginTop: 10,
    alignItems: 'center'
};

export const loginSignupBottomTextFont: CSSProperties = {
    color: midWhite,
    textAlign: 'center',
    marginBottom: 10,
    fontSize: 11,
    cursor: 'pointer'
};

export const loginSignupButton: CSSProperties = {
    width: '100%',
    borderRadius: 5,
    height: 45,
    marginTop: 10,
    backgroundColor: loginSignupLoginButtonColor,
    color: fullWhite,
    fontWeight: 'bold',
    fontSize: 12,
    paddingTop: 4,
    letterSpacing: 1,
    outline: 'none',
    border: 'none',
    marginBottom: 20
};

export const forgotPasswordButton: CSSProperties = {
    width: '100%',
    borderRadius: 5,
    height: 45,
    marginTop: -10,
    backgroundColor: loginSignupLoginButtonColor,
    color: fullWhite,
    fontWeight: 'bold',
    fontSize: 11,
    paddingTop: 4,
    letterSpacing: 1,
    outline: 'none',
    border: 'none',
    marginBottom: 20
};

export const loginSignupHeaderFont: CSSProperties = {
    fontSize: 35,
    color: fullWhite,
    height: 90,
    textAlign: 'center',
    width: 1500
};

export const loginSignupSecondaryHeaderFont: CSSProperties = {
    fontSize: 20,
    color: fullWhite,
    textAlign: 'center',
    width: 1500,
    marginTop: -40,
    marginBottom: 40
};

// export const navigationButtonLink: CSSProperties = {
//     height: 80,
//     width: 80,
//     borderRadius: 40,
//     backgroundColor: '#00000025',
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center'
// };
//
// export const navigationButtonImage: CSSProperties = {
//     height: 35,
//     width: 35,
//     objectFit: 'contain'
// };

// export const relatedFamilyNameText: CSSProperties = {
//     backgroundColor: '#00000000',
//     border: 'none',
//     color: blueColor,
//     marginTop: 38,
//     marginLeft: 2,
//     maxWidth: 160,
//     overflow: 'hidden',
//     textOverflow: 'ellipsis',
//     whiteSpace: 'nowrap'
// };

export const possibleTagStyle: CSSProperties = {
    paddingLeft: 20,
    paddingTop: 10,
    paddingBottom: 10,
    fontSize: 18
};

export const possibleSearchTermDropDown: CSSProperties = {
    position: 'relative',
    zIndex: 999,
    overflowY: 'scroll',
    maxHeight: 600,
    backgroundColor: '#FFFFFFF5',
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5
};

// export const searchTagContainer: CSSProperties = {
//     marginTop: 15,
//     width: '100%',
//     display: 'flex',
//     alignItems: 'center',
//     paddingLeft: '7.6%',
//     paddingRight: '7.5%'
// };
//
// export const searchTagHeader: CSSProperties = {
//     color: 'black',
//     fontSize: 20,
//     fontWeight: 'bolder',
//     marginRight: 20
// };
//
// export const editCollectionArtifactContainer: CSSProperties = {
//     display: 'flex',
//     flexDirection: 'row',
//     marginTop: 20,
//     marginBottom: 20
// };

export const dynamicInputStyle: CSSProperties = {
    height: '100%',
    background: 'none',
    borderStyle: 'solid',
    borderColor: CONSTANTS.COLORS.LIGHT_GREY,
    borderWidth: 0.4,
    fontSize: 18,
    paddingLeft: 60,
    paddingTop: 0,
    color: 'white',
    marginTop: 0
};

export const inputDynamicContainer: CSSProperties = {
    paddingLeft: 110,
    display: 'inline-block',
    flex: 1,
    height: 45
};

export const searchBarImagePlacement: CSSProperties = {
    height: 20,
    width: 20,
    position: 'relative',
    top: 32
};

// export const familyFilterButtonColor = {
//     isSelected: 'black',
//     default: '#CCCCCC'
// };

export const baseDynamicInputMarginLeft = 20;
export const baseDynamicInputMarginTop = 2;
export const baseDynamicSearchBarImagePlacementLeft = 50;
export const basedDynamicMarginLeftForInput = 26;
export const baseDynamicInputWidth = '107%';

export const breakpointDynamicInputMarginLeft = 0;
export const breakpointDynamicInputMarginTop = 4;
export const breakpointDynamicSearchBarImagePlacementLeft = 25;
export const breakpointDynamicMarginLeftForInput = 0;
export const breakpointDynamicInputWidth = '100%';

// export const familyNameTextBufferLeft: CSSProperties = {
//     ...relatedFamilyNameText,
//     marginLeft: 10
// };
//
// export const navigationBuffer = {
//     width: 5
// };
//
// export const updatedTagViewContainer: CSSProperties = {
//     position: 'relative',
//     height: 40,
//     display: 'flex'
// };
//
// export const tagDropDownContainer: CSSProperties = {
//     position: 'relative',
//     height: 40,
//     width: 100,
//     top: 90,
//     left: 170,
//     backgroundColor: '#00000033',
//     display: 'flex',
//     flexDirection: 'row',
//     alignItems: 'center',
//     paddingRight: 10,
//     zIndex: 999
// };
//
// export const tagDropDownArrow: CSSProperties = {
//     height: 15,
//     width: 15,
//     objectFit: 'contain',
//     marginTop: 6
// };
//
// export const tagDisplayText: CSSProperties = {
//     color: 'white',
//     textAlign: 'right',
//     width: '100%',
//     fontSize: 17,
//     marginTop: 5,
//     marginRight: 10
// };
//
// export const newArtifactCellImage: CSSProperties = {
//     marginBottom: 5,
//     width: '100%',
//     height: 130,
//     objectFit: 'cover',
//     marginLeft: 10,
//     marginRight: 10
// };
//
// export const tagFieldContainer: CSSProperties = {
//     width: '100%',
//     display: 'flex',
//     flexDirection: 'row',
//     alignItems: 'flex-start'
// };
//
// export const tagFieldButton: CSSProperties = {
//     backgroundColor: 'none',
//     outline: 'none',
//     border: 'none',
//     cursor: 'pointer',
//     fontWeight: 'bold',
//     color: darkBlueColor,
//     fontSize: 14,
//     marginTop: 16,
//     marginLeft: 6
// };
//
// export const artifactNameInputField: CSSProperties = {
//     height: 40,
//     width: 254,
//     marginLeft: 8,
//     marginRight: 8,
//     paddingLeft: 20,
//     margin: 0,
//     marginBottom: -12,
//     marginTop: 12,
//     outline: 'none',
//     border: '0.5px solid #00000021',
//     fontSize: 15
// };
//
// export const dropDownArrow: CSSProperties = {
//     height: 20,
//     width: 13,
//     position: 'relative',
//     top: 33,
//     left: 192.5,
//     objectFit: 'contain',
//     opacity: 0.3,
//     cursor: 'pointer'
// };
//
// export const tagInputFieldContainer: CSSProperties = {
//     width: '100%',
//     display: 'flex',
//     flexDirection: 'row',
//     alignItems: 'flex-start',
//     marginLeft: -10
// };
//
// export const tagInputField: CSSProperties = {
//     height: 40,
//     width: 225,
//     paddingLeft: 20,
//     marginLeft: 13,
//     outline: 'none',
//     border: '0.5px solid #00000021',
//     fontSize: 15
// };
//
// export const checkMarkImage: CSSProperties = {
//     height: 40,
//     width: 24,
//     marginLeft: 6,
//     paddingLeft: 4,
//     opacity: 0.2,
//     objectFit: 'contain',
//     cursor: 'pointer'
// };

export const fadedXButtonContainer: CSSProperties = {
    width: 50,
    height: 50,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

export const fadedXButton: CSSProperties = {
    width: 15,
    height: 15,
    objectFit: 'contain'
};

export const largeXFamilyButtonImage: CSSProperties = {
    height: 40,
    width: 40,
    position: 'relative',
    objectFit: 'contain',
    bottom: 260,
    right: '-87%'
};

export const profileContainer: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
};

export const tagRowDisplay: CSSProperties = {
    display: 'flex',
    maxWidth: 400,
    flexWrap: 'wrap'
};

export const potentialInviteContainer: CSSProperties = {
    width: '100%',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 25
};

export const userListContainer: CSSProperties = {
    marginTop: 20,
    paddingLeft: 13
};

export const usersFont: CSSProperties = {
    fontSize: 16,
    color: blueColor
};

export const usersList: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
};

export const removeUserButton: CSSProperties = {
    height: 10,
    width: 10,
    marginLeft: 10,
    objectFit: 'contain'
};

// export const newArtifactCollectionContainer: CSSProperties = {
//     display: 'flex',
//     flexDirection: 'column',
//     minHeight: 435,
//     marginTop: 25,
//     paddingLeft: 5
// };
//
// export const artifactTagDropdownContainer: CSSProperties = {
//     display: 'flex',
//     flexWrap: 'wrap',
//     width: '100%',
//     marginLeft: 50
// };
//
// export const whiteXButton: CSSProperties = {
//     marginLeft: 10,
//     marginRight: 10,
//     height: 12,
//     width: 12,
//     objectFit: 'contain'
// };
//
// export const closeModalButton: CSSProperties = {
//     width: 30,
//     height: 30,
//     backgroundColor: 'none',
//     outline: 'none',
//     objectFit: 'contain',
//     border: 'none',
//     marginRight: 15,
//     marginTop: 0,
//     cursor: 'pointer'
// };
//
// export const fullSizeImage: CSSProperties = {
//     height: '100%',
//     width: '100%',
//     objectFit: 'contain'
// };
//
// export const addButton: CSSProperties = {
//     backgroundColor: CONSTANTS.COLORS.DARK_BLUE_GREY,
//     outline: 'none',
//     border: 'none',
//     boxShadow: largeShadow,
//     height: 40,
//     width: 43,
//     borderRadius: 3,
//     cursor: 'pointer',
//     color: 'white',
//     fontSize: 16,
//     marginTop: 16,
//     paddingTop: 4,
//     whiteSpace: 'nowrap'
// };
//
// export const leftSideUploadContainer: CSSProperties = {
//     width: 450,
//     height: '100%'
// };
//
// export const rightSideUploadContainer: CSSProperties = {
//     width: 1000,
//     overflowY: 'scroll',
//     maxHeight: 660
// };
//
// export const uploadLimitWarning: CSSProperties = {
//     textAlign: 'center',
//     marginTop: 100
// };

export const inviteButton: CSSProperties = {
    ...uploadArtifactButton,
    width: 165,
    float: 'right',
    marginRight: 35
};

// export const tagSubmitButton: CSSProperties = {
//     float: 'right',
//     color: darkBlueColor,
//     cursor: 'pointer'
// };

export const artifactTitle: CSSProperties = {
    fontSize: 22,
    color: darkestGrey
};

export const artifactImage: CSSProperties = {
    height: 270,
    width: 560,
    objectFit: 'cover'
};

// export const collectionImageContainer: CSSProperties = {
//     height: 130,
//     width: 160,
//     objectFit: 'cover',
//     marginRight: 15,
//     boxShadow: cardShadow,
//     borderRadius: 2
// };
//
// export const collectionPreviewImage: CSSProperties = {
//     height: '100%',
//     width: '100%',
//     objectFit: 'cover',
//     boxShadow: cardShadow,
//     borderRadius: 2
// };
//
// export const collectionExtraCountContainer: CSSProperties = {
//     height: 130,
//     width: 160,
//     boxShadow: cardShadow,
//     borderRadius: 2,
//     marginRight: 15
// };
//
// export const extraCountContainer: CSSProperties = {
//     position: 'relative',
//     height: '100%',
//     width: '100%',
//     backgroundColor: '#00000035',
//     top: '-100%',
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     paddingTop: 6
// };
//
// export const extraCountCollectionText: CSSProperties = {
//     color: 'white',
//     fontSize: 37,
//     textAlign: 'center'
// };

export const listItemStyle: CSSProperties = {
    height: 40,
    display: 'flex',
    alignItems: 'center',
    borderBottom: '0.5px solid rgba(0,0,0,0.267)',
    paddingLeft: 20
};

export const inviteInput: CSSProperties = {
    outline: 'none',
    width: '100%',
    height: '100%',
    paddingLeft: 20,
    border: '0.5px solid rgba(0, 0, 0, 0.2)'
};

export const loginText: CSSProperties = {
    marginLeft: 5,
    color: '#FFFFFFCC'
};

export const fullFlexRowCenter: CSSProperties = {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
};

export const flexRowItemCenter: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
};

export const commentAuthorNameText: CSSProperties = {
    whiteSpace: 'nowrap',
    width: '100%',
    fontWeight: 'bold',
    fontSize: 20,
    marginTop: 6,
    marginLeft: 10,
    fontStyle: 'italic',
    color: 'black'
};

export const authorPostTimeText: CSSProperties = {
    whiteSpace: 'nowrap',
    fontWeight: 'bolder',
    fontSize: 16,
    color: 'black',
    marginTop: 10
};

export const commentText: CSSProperties = {
    marginLeft: 60,
    fontSize: 18,
    marginTop: 15,
    marginBottom: 10
};

export const newCommentColor = '#00000011';

export const childCommentAuthorImage: CSSProperties = {
    height: 50,
    width: 50,
    borderRadius: 25,
    objectFit: 'cover',
    boxShadow: largeShadow
};

export const replyButton: CSSProperties = {
    color: '#CB6C3C',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    fontWeight: 'bolder'
};

export const hideRepliesButton: CSSProperties = {
    color: '#CB6C3C',
    whiteSpace: 'nowrap',
    marginLeft: 7,
    paddingLeft: 7,
    cursor: 'pointer',
    fontWeight: 'bolder',
    borderLeft: '1px solid black'
};

export const childRepliesBorder = {
    borderLeft: '3px solid rgba(0,0,0,0.33)',
    marginLeft: 50
};

// export const relatedFamiliesPaddingAdjustment = {
//     paddingLeft: 7
// };
//
// export const boldPointer: CSSProperties = {
//     cursor: 'pointer',
//     fontWeight: 'bolder'
// };
//
// export const dropDownPadding = {
//     paddingTop: 38,
//     marginLeft: 10
// };

export const innerSubCommentInputContainer = {
    width: '100%',
    height: 200,
    backgroundColor: '#00000000',
    marginBottom: 20,
    paddingLeft: 50,
    paddingTop: 10
};

export const subCommentInputTextArea: CSSProperties = {
    width: '100%',
    height: 160,
    backgroundColor: 'white',
    outline: 'none',
    fontSize: 16,
    padding: 25,
    resize: 'none',
    border: '1px solid rgba(0,0,0, 0.265)'
};

export const subCommentInputCancelButton: CSSProperties = {
    height: 40,
    backgroundColor: '#00000000',
    border: 'none',
    color: darkBlueColor,
    fontWeight: 'bold',
    cursor: 'pointer',
    marginRight: 10
};

export const subCommentInputSubmitButton: CSSProperties = {
    height: 40,
    backgroundColor: '#00000000',
    border: 'none',
    color: darkBlueColor,
    fontWeight: 'bold',
    cursor: 'pointer'
};

export const noBorderFullWidth: CSSProperties = {
    border: 'none',
    width: '100%'
};

export const flexCenter: CSSProperties = {
    display: 'flex',
    alignItems: 'center'
};

export const changePictureButton = {
    width: 150,
    marginTop: 20
};

export const userPreferencesHeader = {
    fontSize: 22,
    color: darkestGrey,
    marginBottom: 20
};

export const pointer = {
    cursor: 'pointer'
};

export const fullHeight = {
    height: '100%'
};

export const finishMarginTop = {
    marginTop: 29
};

// export const breadCrumbTrailContainer = {
//     width: 1,
//     height: 35,
//     backgroundColor: '#00000099',
//     marginRight: 25,
//     marginTop: -2
// };
//
// export const takeMeBackContainer: CSSProperties = {
//     display: 'flex',
//     flexDirection: 'row',
//     justifyContent: 'center',
//     alignItems: 'center',
//     cursor: 'pointer',
//     paddingTop: 2
// };
//
// export const takeMeBackButtonImage = {
//     height: 18,
//     paddingtop: 2,
//     width: 30,
//     objectFit: 'contain',
//     marginRight: 5,
//     marginLeft: 3,
//     cursor: 'pointer',
//     marginTop: -5
// };
//
// export const takeMeBackButtonText = {
//     color: darkBlueColor,
//     marginRight: 25,
//     whiteSpace: 'nowrap'
// };
//
// export const gutterObject = {
//     width: 1,
//     height: 35,
//     backgroundColor: '#00000099',
//     marginRight: 25,
//     marginTop: -2
// };
//
// export const familyBackButtonGutter = {
//     width: 1,
//     height: 35,
//     backgroundColor: '#00000099',
//     marginRight: 25
// };
//
// export const familyDetailBackButton = {
//     color: darkBlueColor,
//     whiteSpace: 'nowrap',
//     paddingTop: 1.5
// };
//
// export const fullFlexWidth = {
//     width: '100%',
//     display: 'flex'
// };
//
// export const familyManagementButtonContainer: CSSProperties = {
//     width: '100%',
//     height: '100%',
//     display: 'flex',
//     flexDirection: 'row',
//     alignItems: 'center'
// };
//
// export const familyManagementButtonText: CSSProperties = {
//     whiteSpace: 'nowrap',
//     marginLeft: 60,
//     marginTop: 5,
//     display: 'flex',
//     color: '#00000BB',
//     cursor: 'pointer',
//     fontSize: 18
// };
//
// export const subNavCollectionsContainer: CSSProperties = {
//     display: 'flex',
//     height: '100%',
//     width: '100%',
//     alignItems: 'center',
//     justifyContent: 'space-between'
// };
//
// export const emptyScreenUnderModalContainer = {
//     height: 300,
//     width: 300,
//     marginTop: 35,
//     marginLeft: '7.8%'
// };

export const fullWidthWhite = {
    width: '100%',
    height: '100%',
    backgroundColor: 'white'
};

// export const hasChosenOptionTextColor = {
//     color: 'black'
// };

// export const headerMargin = {
//     marginLeft: 276
// };
//
// export const newOptionInputStyle: CSSProperties = {
//     display: 'flex',
//     flexDirection: 'row',
//     alignItems: 'center',
//     width: '100%'
// };

// export const newOptionInput: CSSProperties = {
//     marginTop: 15,
//     width: 350,
//     marginRight: 7
// };
//
// export const tagSubmitContainer: CSSProperties = {
//     width: 292,
//     paddingTop: 10
// };

export const signInText = {
    marginLeft: 5,
    color: '#FFFFFFCC'
};

export const createFamilyButtonContainer = {
    height: 50,
    width: '100%'
};



// WEBPACK FOOTER //
// ./src/styles/styleObjects.ts